import React from 'react';
import config from 'config';
import Checkbox from 'components/checkbox';
import TablePagination from 'components/TablePagination';
import ContactAvatar from 'components/ContactAvatar';
import MembersTableToolbar from './MembersTableToolbar';
import MembersTableRowActions from './MembersTableRowActions';
import MemberStatus from './MemberStatus';
import MemberRole from './MemberRole';
import MemberCustomStatus from "./MemberCustomStatus";
import Input from "../../../../../components-new/Input";
import CustomSelect from 'components/select';
import FileUpload from "../../../../../components/FileUpload";
import Translate from "../../../../../components/Translate";
import {tabButtonStyles} from "../../../../../utils/General";

class EmployeesTable extends React.Component {
    state = {
        activeTab: 'mainInfo',
    };

    setActiveTab = (tab) => {
        this.setState({activeTab: tab});
    };

    render() {
        const {
            numSelected,
            selectedMembers,
            searchString,
            handleSearch,
            handleRemoveMembers,
            user,
            columnData,
            order,
            orderBy,
            filteredMembers,
            pageData,
            chatLimit,
            currentChatLimit,
            rowsPerPage,
            page
        } = this.props;

        const {activeTab} = this.state;

        return (
            <div>
                <div style={tabButtonStyles.tabButtons}>
                    <button style={tabButtonStyles.tabButton(activeTab === 'mainInfo')}
                            onClick={() => this.setActiveTab('mainInfo')}>
                        <Translate text="mainInfo"/>
                    </button>
                    <button style={tabButtonStyles.tabButton(activeTab === 'other')}
                            onClick={() => this.setActiveTab('other')}>
                        <Translate text="other"/>
                    </button>
                </div>

                <MembersTableToolbar
                    numSelected={numSelected}
                    searchString={searchString}
                    handleSearch={handleSearch}
                    removeMembers={handleRemoveMembers(selectedMembers)}
                    user={user}
                />

                <div style={{overflow: 'auto', maxHeight: '50vh', minHeight: '50vh'}}>
                    <table className="custom-table">
                        <thead className="thead1">
                        <tr>
                            <th></th>
                            <th><Translate text={'employee'}/></th>
                            {activeTab === 'mainInfo' && (
                                <React.Fragment>
                                    <th style={{textAlign: 'center'}}><Translate text={'Status'}/></th>
                                    <th style={{textAlign: 'center'}}><Translate text={'currentStatus'}/></th>
                                    <th style={{textAlign: 'center'}}><Translate text={'Role'}/></th>
                                </React.Fragment>
                            )}
                            {activeTab === 'other' && (
                                <React.Fragment>
                                    <th style={{textAlign: 'center'}}><Translate text={'language'}/></th>
                                    <th style={{textAlign: 'center'}}><Translate text={'chatLimit'}/></th>
                                    <th style={{textAlign: 'center'}}><Translate text={'currentChatLimit'}/></th>
                                    <th style={{textAlign: 'center'}}><Translate text={'password'}/></th>
                                </React.Fragment>
                            )}
                            <th style={{textAlign: 'center'}}><Translate text={'actions'}/></th>
                        </tr>
                        </thead>
                        <tbody>
                        {pageData.map((n) => {
                            const isRowSelected = this.props.isSelected(n.id);

                            return (
                                <tr
                                    className="tr-body1"
                                    key={n.id}
                                    style={{
                                        opacity: n.role === config.rolesMap.owner ? '0.5' : '1',
                                        pointerEvents: n.role === config.rolesMap.owner ? 'none' : 'all',
                                    }}
                                >
                                    <td style={{width: '30px', textAlign: 'center'}}>
                                        <Checkbox
                                            handleChange={this.props.handleMemberSelectChange(n.id)}
                                            checked={isRowSelected}
                                            size="15px"
                                            wrapperStyle={{height: '15px'}}
                                        />
                                    </td>

                                    <td className="clickable-td">
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            {!n.platformId ? (
                                                <ContactAvatar contact={n} inChatMenu={true}/>
                                            ) : (
                                                <FileUpload
                                                    windowSize={35}
                                                    editIconSize={17}
                                                    progressSize={22}
                                                    editIconPos={0}
                                                    handleChange={(link) => {
                                                        this.props.handleOperatorInfoChange(n.id, 'thumbUrl', link);
                                                    }}
                                                    image={n.thumbUrl}
                                                />
                                            )}

                                            <div style={{marginLeft: '12px', display: 'flex', flexDirection: 'column'}}>
                                                <div style={{display: 'flex', gap: '8px', marginBottom: '4px'}}>
                                                    {n.platformId && (
                                                        <React.Fragment>
                                                            <Input
                                                                type="text"
                                                                defaultValue={n.firstName}
                                                                onBlur={(e) =>
                                                                    this.props.handleOperatorInfoChange(n.id, 'firstName', e.target.value)
                                                                }
                                                            />
                                                            <Input
                                                                type="text"
                                                                defaultValue={n.lastName}
                                                                onBlur={(e) =>
                                                                    this.props.handleOperatorInfoChange(n.id, 'lastName', e.target.value)
                                                                }
                                                            />
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                                <span style={{fontSize: '12px', color: '#666'}}>{n.email}</span>
                                            </div>
                                        </div>
                                    </td>


                                    {activeTab === 'mainInfo' && (
                                        <React.Fragment>
                                            <td style={{textAlign: 'center'}} className="clickable-td">
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    <MemberStatus
                                                        member={n}
                                                        updateStatus={this.props.handleMemberStatusChange(n)}
                                                    />
                                                </div>
                                            </td>
                                            <td style={{textAlign: 'center'}} className="clickable-td">
                                                {n.platformId && (
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <MemberCustomStatus
                                                            member={n}
                                                            updateCurrentStatus={this.props.handleMemberCurrentStatusChange(n)}
                                                        />
                                                    </div>
                                                )}
                                            </td>
                                            <td style={{textAlign: 'center'}} className="clickable-td">
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    <MemberRole member={n}
                                                                updateRole={this.props.handleMemberRoleChange(n)}/>
                                                </div>
                                            </td>
                                        </React.Fragment>
                                    )}

                                    {activeTab === 'other' && (
                                        <React.Fragment>
                                            <td style={{textAlign: 'center'}} className="clickable-td">
                                                {n.platformId && (
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <CustomSelect
                                                            wrapperStyles={{boxShadow: 'none', display: 'inline-block'}}
                                                            titleStyles={{color: '#09183A'}}
                                                            listStyles={{boxShadow: 'none', width: '170%'}}
                                                            options={config.locales2}
                                                            title={n.language}
                                                            handleSelect={(e) =>
                                                                this.props.handleOperatorInfoChange(n.id, 'language', e)
                                                            }
                                                            width="100px"
                                                        />
                                                    </div>
                                                )}
                                            </td>
                                            <td style={{textAlign: 'center'}} className="clickable-td">
                                                {n.platformId && (
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <Input
                                                            type="number"
                                                            value={chatLimit[n.platformId] || n.chatLimit}
                                                            onChange={this.props.handleChatLimitChange(n.platformId)}
                                                            onBlur={this.props.handleChatLimitBlur(n.platformId)}
                                                        />
                                                    </div>
                                                )}
                                            </td>
                                            <td style={{textAlign: 'center'}} className="clickable-td">
                                                {n.platformId && (
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <Input
                                                            type="number"
                                                            value={currentChatLimit[n.platformId] || n.currentChatLimit}
                                                            onChange={this.props.handleCurrentChatLimitChange(n.platformId)}
                                                            onBlur={this.props.handleCurrentChatLimitBlur(n.platformId)}
                                                        />
                                                    </div>
                                                )}
                                            </td>
                                            <td style={{textAlign: 'center'}} className="clickable-td">
                                                {n.platformId && (
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <Input
                                                            type="text"
                                                            value={this.props.passwordsForChange[n.platformId] || "********"}
                                                            onChange={this.props.handleMemberPasswordChange(n.platformId)}
                                                            onBlur={this.props.handleMemberPasswordBlur(n.platformId)}
                                                        />
                                                    </div>
                                                )}
                                            </td>
                                        </React.Fragment>
                                    )}

                                    <td className="clickable-td">
                                        <MembersTableRowActions
                                            member={n}
                                            removeMember={this.props.handleRemoveMembers([n])}
                                            reInviteMember={this.props.reInviteMember}
                                            user={user}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>

                <TablePagination
                    totalRows={filteredMembers.length}
                    numberOfPages={Math.ceil(filteredMembers.length / rowsPerPage)}
                    handleChangeRowsPerPage={this.props.handleChangeRowsPerPage}
                    rowsPerPage={rowsPerPage}
                    curPage={page}
                    selectPage={this.props.handleChangePage}
                />
            </div>
        );
    }
}

export default EmployeesTable;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/EmployeesTable.jsx